<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_21" title="[21]"></span>
<h2 class="nobreak" id="pgepubid00006">CHAPTER III<br class="calibre15"/>
<span class="small">IN THE FOREST</span></h2>
</div>
<p class="calibre3"><span class="smcap">Dave</span> and his cousin Henry occupied a small bedroom
at the north end of the cabin. Like the other
apartments, this was unplastered excepting for some
clay stuck in the chinks to keep out the wind. The
room boasted of one window, a foot and a half
square, and fitted with a heavy wooden shutter, to
be closed in winter, or when there was danger of
an attack.</p>
<p class="calibre3">Three-quarters of the floor space was taken up
by the heavy four-posted bedstead, built of black
walnut and hickory and almost as hard and as heavy
as iron. The bed was corded with rawhide, on which
rested a mattress of straw and a long pillow filled
with chicken feathers. In front of the bed, and directly
under the window, ran a bench the length of
the room, and above was a row of pegs upon which
the boys could hang their clothing. The ceiling was
so low that the boys could jump up and touch it with
ease.</p>
<p class="calibre3">By the time the boys had said their prayers and<span id="Page_22" title="[22]"></span>
retired, a deep silence had fallen on the cabin and its
surroundings, broken only by the faint gurgling of
the brook as it tumbled along over the rocks and the
soft fall breeze as it swept through the forest beyond
the clearing, sending the golden leaves down in showers.
Presently the moon shone over the top of the
distant mountains, tipping the brook here and there
with silver. The shining of the orb of night seemed
to displease the wolves, and soon one and another
let up a lonely howl, ending in a chorus which was
truly dismal. But those in the cabin were used to
such sounds and were not disturbed. White Buffalo
uttered a long sigh and then began to snore, as if
in answer to the beasts outside.</p>
<p class="calibre3">The moon still hung low in the heavens, as if loath
to give place to the rising sun, when Joseph Morris
arose, followed by his wife, and set about preparing
the morning meal. White Buffalo was already up
and sat on the doorstep, cutting out a wooden trinket
with his knife. With this trinket he intended to make
friends with little Nell, who so far, had proved rather
afraid of him.</p>
<p class="calibre3">“White Buffalo make little Nell a wooden pappoose,”
he said, when the six-year-old came from
her bedroom and shyly approached to see what he
was doing. “Little Nell can dress the pappoose and
make much play.”</p>
<p class="calibre3"><span id="Page_23" title="[23]"></span>“Oh, a doll!” cried the girl, and much of her
shyness vanished. She looked it over. “Why, it
hasn’t any arms!”</p>
<p class="calibre3">“White Buffalo make arms by-me-by, and feet,
too. Make arms and feet fast with sticks, so little
Nell can move them and make head fast with stick,
too, so pappoose can look over shoulder and all
around. Heap big pappoose then, much proud!”</p>
<p class="calibre3">“That will be nice,” answered Nell and smiled
frankly into the Indian’s face. Then the two consulted
about the length of the legs and arms to be
put on the doll, and before breakfast was ready they
were firm friends. When finished the doll was decidedly
crude and had a strong Indian expression on
its straight-nosed face, but this Nell did not seem
to mind. She possessed but few toys and this was
her first doll, and she cherished it accordingly.</p>
<p class="calibre3">Joseph Morris felt that he would have to go direct
to Annapolis for the majority of the things his
brother wished, so preparations for such a journey
were made. Such a trip was quite an event, and
Henry Morris was sent around to several of the neighbors,
who might desire some commission executed in
town. Annapolis was rapidly becoming a place of
considerable importance, with a growing trade in
tobacco, hemp, and other commodities.</p>
<p class="calibre3">It was a cool, crisp day when Joseph Morris and<span id="Page_24" title="[24]"></span>
Dave set out on their journey. They were on horseback,
and several neighbors came to see them
off and incidentally to load them with further commissions,
which had been forgotten until the last
moment.</p>
<p class="calibre3">“Take care of yourself, Joseph,” said Mrs. Morris,
on parting. “And you be careful, too, Dave,” and
then she kissed both her husband and her nephew affectionately.
Little Nell also came in for a hug and a
kiss, and the others for a handshake.</p>
<p class="calibre3">The distance to the trading-post at Will’s Creek
was three miles, and the distance from the post to
Winchester, then nothing but another frontier post,
was about forty-five miles. But the wagon road
from one place to the other had not yet been cut
through, and the trail ran in and out along the river
and through the forest, making the distance to be
traversed at least sixty miles. The mountain pass
was a difficult one and at one point ran around the
edge of a cliff forty to fifty feet high. Here a tumble
for man or beast to the jagged rocks below would
have meant instant death.</p>
<p class="calibre3">But Dave thought of none of these perils as he
rode beside his uncle or directly behind him. He
had a good mount and a good rifle, and his aunt had
fairly stuffed their saddle bags with good things to
be eaten on the way. The lad saw nothing but a<span id="Page_25" title="[25]"></span>
grand outing ahead and whistled cheerily in consequence.</p>
<p class="calibre3">Mr. Morris was more thoughtful and so pre-occupied
that he scarcely noticed Dave’s rendering of
“The Pirate’s Lady, Oh!” and of “Lucy Locket
Lost Her Pocket,” afterward known universally as
“Yankee Doodle.” The tunes were whistled half a
dozen times, and then of a sudden the lad turned
to his relative.</p>
<p class="calibre3">“Uncle Joe, what are you so silent about? You
haven’t spoken since we passed the old fish hole.”</p>
<p class="calibre3">“Is that so, Dave?” was the answer. “Well, to
tell the truth I was thinking of many things—of the
articles we are to buy and where I could probably
get them cheapest, and of the talk we had with
White Buffalo about the trouble with the French.”</p>
<p class="calibre3">“Do you think we will have trouble with the
French?”</p>
<p class="calibre3">“I cannot see how it can be avoided. As I understand
it, when the treaty of peace was signed at Aix-la-Chapelle
nothing was said about the English and
French possessions in western America. Now the
French discoverers have sailed down the Ohio and
the Mississippi, and consequently they may claim the
land by right of discovery, especially when they realize
the value for trading-posts and for cattle and
farm lands.”</p>
<p class="calibre3"><span id="Page_26" title="[26]"></span>“But can they claim the land when they sail only
on the <i class="calibre12">water</i>?”</p>
<p class="calibre3">“They hold that a discoverer sailing along an unknown
river can lay claim to all lands drained by
that river, or by creeks flowing into it. But this is
absurd when it comes to such a stream as the Mississippi
which is the basin for miles and miles of
territory, or even with such a river as the Ohio.”</p>
<p class="calibre3">“When did they discover the Mississippi?”</p>
<p class="calibre3">“About seventy-five years ago one Padre Marquette
sailed down the stream for several hundred
miles, in company with a friend named Joliet. They
were French subjects and took possession, so-styled,
in the name of the King of France.”</p>
<p class="calibre3">“But what about our claim?”</p>
<p class="calibre3">“Well, to tell the truth, our claim isn’t much
better than that of the French. In 1741 the commissioners
from Virginia, Maryland and Pennsylvania
met a number of head chiefs of the Six
Nations, and the Indians, for four hundred pounds,
gave up all their claims to the land lying this side
of the Mississippi.”</p>
<p class="calibre3">“Well, that claim ought to be all right, it seems
to me.”</p>
<p class="calibre3">“It is all right for the land this side of the Alleghany
Mountains, but as for the other I doubt if the
Six Nations had any right to deed it away. They<span id="Page_27" title="[27]"></span>
never lived on it and the story that they once conquered
it is only a tradition.”</p>
<p class="calibre3">“Well, who does the land belong to?”</p>
<p class="calibre3">“To the Indians first, and then to the white people
who establish themselves on it. As to what nation
shall rule, our country and France will have to settle
that between them.”</p>
<p class="calibre3">“Then war must surely come?”</p>
<p class="calibre3">“Probably; although the folks in Europe may
have enough of fighting for the present. Very few
have forgotten the hardships of the last struggle or
the distress which followed. For myself, I do not
wish to live to see another war, either with the Indians
or the French.”</p>
<p class="calibre3">“Have the French any regular settlement on the
Ohio and the Mississippi?”</p>
<p class="calibre3">“I don’t know of any settlement on the Mississippi,
but their fur traders are on the upper Ohio,
Sam Barringford met several of them when he was
on a hunt with White Buffalo. He said they were a
lawless set, some of them half-breeds, and they would
get the Indians drunk on rum and then literally rob
them of their pelts. I shouldn’t be surprised if the
Indians rose up some time and wiped them all out
in revenge.”</p>
<p class="calibre3">“If the French traders are that sort do you think
they will bring trouble to father?”</p>
<p class="calibre3"><span id="Page_28" title="[28]"></span>“They are not all that sort. Here and there you
will find a good-enough fellow. As to bringing
trouble, though, that’s another question. You know
when an Indian goes on the warpath he is apt to get
excited and then perhaps one trader will look just
as black to him as another. But your father didn’t
go to trade in rum, and he expected to give the
redskins honest value for their hides, so they may
remain his friends even if they do rise.”</p>
<p class="calibre3">“I think war is a dreadful thing, Uncle Joe, and
I can’t see why civilized nations should fight each
other. It’s bad enough for the redskins to do
that.”</p>
<p class="calibre3">“True enough, Dave, but I imagine there will be
fighting to the end of time. It’s a sort of court
of last resort, you know; first folks argue, then they
make demands, and at last they fight, and there
doesn’t seem to be any help for it. But it’s truly a
pity England and France can’t agree—they’ve
pitched into each other so many times.”</p>
<p class="calibre3">The pair had now reached the end of the trail
beside the creek and for the time being the conversation
came to an end. There was a small brook to
ford and then the side of a hill to climb. Here the
giant trees sent their roots sprawling in all directions
and they had to proceed with care lest one of the
steeds might stumble and break a leg. The forest<span id="Page_29" title="[29]"></span>
was dense, for a woodman’s axe had never yet entered
it, and in some spots the gloom was intense
while at others the faint rays of sunshine piercing
the boughs above served only to intensify the darkness.
In spots the trail was very damp and the trees
covered with fungi, in other places there were patches
of green moss as soft as the most delicate carpet.
Here and there the boughs hung so low they had to
lift them to get past.</p>
<p class="calibre3">“What a solitude!” remarked Joseph Morris, as
they came to a halt in a glade surrounded by stately
walnuts. They held up their heads to listen. Not
a sound broke the stillness close around them. From
afar came the songs of birds and the chant of some
swamp frogs. Around them floated butterflies of
various hues, and presently came a cluster of honey
bees, heading for an old tree they had just passed.
At once all else was forgotten by Joseph Morris but
the bees.</p>
<p class="calibre3">“A bee tree, Dave!” he cried. “See, we are in
luck for once!”</p>
<p class="calibre3">“A bee tree, true enough!” echoed the youth.
“It ought to be pretty well filled with honey by this
time, too. Of course you’ll mark it, Uncle Joe.”</p>
<p class="calibre3">“To be sure, although I shouldn’t forget it very
easily—being so close to this opening and so near
to the trail. But we’ll mark it, so that nobody else<span id="Page_30" title="[30]"></span>
can claim it between now and the time we come for
the honey.”</p>
<p class="calibre3">Approaching the tree with caution Joseph Morris
noticed the bees go into an opening just above the
lower branches. His experienced eye told him that
there was here a hive of considerable size with a
good many pounds of honey in it. He marked the
tree with care, so that it now became his property
by right of discovery.</p>
<p class="calibre3">“We’ll gather in that honey just as soon as we
return from Annapolis,” he said. “It will please
mother I’m sure, for we are short on sweets for this
winter.”</p>
<p class="calibre3">And then they proceeded once more on their way.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?11d6e4a9